export default {
  CONFIANZA_ONLINE: 'confianza-online',
  GOOGLE_REVIEWS: 'google-reviews',
  TRUSTED_SHOPS: 'trusted-shops',
  TRUSTPILOT: 'trustpilot',
  NONE: 'none',
}
